import React from 'react';
import { Box } from '@mui/material';

const PILL_BASE = {
  width: 'fit-content',
  maxWidth: '100%',
  padding: '4px 12px',
  borderRadius: '100px',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: 'auto',
  minHeight: '24px',
  boxSizing: 'border-box',
  whiteSpace: 'nowrap',
  fontSize: '12px',
  fontWeight: 600,
  lineHeight: 1.25,
};

/** Colored status pill aligned inside a list cell. */
const StatusPill = ({ children, colorStyle, justify = 'center' }) => (
  <Box sx={{ display: 'flex', justifyContent: justify, width: '100%' }}>
    <Box style={{ ...PILL_BASE, ...colorStyle }}>{children}</Box>
  </Box>
);

export default StatusPill;
